import type React from 'react';
import SvgIcon from './SvgIcon';

const LoudSpeaker: React.FC = () => (
  <SvgIcon
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="none"
  >
    <g id="LoudSpeaker">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7656 0.028911C19.0635 -0.042994 19.3783 0.0248863 19.6191 0.214458C19.8599 0.404069 20 0.694145 20 1.00059V14.5006C19.9999 14.8095 19.8573 15.1013 19.6133 15.2906C19.369 15.4799 19.0502 15.5463 18.751 15.4693L10.5 13.3443V13.4752C10.4998 15.4096 8.69552 16.8391 6.8125 16.3961L6.5625 16.3365C5.2077 16.0175 4.25014 14.8085 4.25 13.4166V11.5846L0.723633 10.5699C0.295305 10.4467 0.000116417 10.0547 0 9.60899V5.34825C7.74854e-05 4.8865 0.31678 4.48501 0.765625 4.37657L18.7656 0.028911ZM6.25 13.4166C6.25014 13.8805 6.56987 14.284 7.02148 14.3902L7.27148 14.4488C7.89893 14.5961 8.49984 14.1197 8.5 13.4752V12.8072L6.25 12.1607V13.4166ZM2 6.13536V8.85606L9.74902 11.0865L18 13.2096V2.27012L2 6.13536Z"
        fill="currentColor" />
    </g>
  </SvgIcon>
);

export default LoudSpeaker;
